import { ActivityIcon } from '../Icon';
import type { ActivityType } from 'types';
import { HTMLAttributeAnchorTarget, ReactElement } from 'react';
import { TitleContainer } from 'components/TitleContainer';
import { Box } from '@ff-it/ui';
import { EnterpriseLink } from 'components/EnterpriseLink';
import { clampLine } from 'styles/style.css';

export interface BlockWidgetProps {
  id: number;
  code: string;
  title: string;
  campaign_id?: number;
  final_client_po_number: string | null;
  type: ActivityType;
  flat?: boolean;
}

export function BlockWidget({
  id,
  code,
  title,
  campaign_id,
  link,
  type,
  className,
  flat,
  clamp,
  target = '_blank',
}: BlockWidgetProps & {
  link?: boolean;
  target?: HTMLAttributeAnchorTarget;
  className?: string;
  clamp?: boolean;
}): ReactElement {
  const content =
    link && campaign_id ? (
      <EnterpriseLink to={`/planning/campaigns/${campaign_id}/planning/${id}`} target={target}>
        {title || type}
      </EnterpriseLink>
    ) : (
      title || type
    );

  // `clamp` truncates the title to one line with an ellipsis — for constrained table cells. Off by default so
  // dropdown/list usages (react-select options, linker rows) keep the full title (minWidth:0 would otherwise
  // let them shrink and truncate). A flex child won't ellipsize via TitleContainer's title, hence the inner Box.
  const titleNode = clamp ? (
    <Box display="flex" alignItems="center" style={{ minWidth: 0 }}>
      <ActivityIcon type={type} className="mr-1" />
      <Box className={clampLine} style={{ minWidth: 0 }}>
        {content}
      </Box>
    </Box>
  ) : (
    <Box display="flex">
      <ActivityIcon type={type} className="mr-1" /> {content}
    </Box>
  );

  return <TitleContainer testId={`block-${id}`} className={className} flat={flat} title={titleNode} subtitle={code} />;
}
